document.addEventListener("DOMContentLoaded", function () {
  const fadeItems = document.querySelectorAll(".aura-fade-up");

  if (fadeItems.length) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    fadeItems.forEach(function (item) {
      observer.observe(item);
    });
  }

  const auraHeader = document.querySelector(".aura-header");

  if (auraHeader) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 40) {
        auraHeader.classList.add("is-scrolled");
      } else {
        auraHeader.classList.remove("is-scrolled");
      }
    });
  }
});